module.exports = __webpack_public_path__ + "images/iphone-d8b499.png";